import { webDeleteReq, webGetReq, webPatchReq, webPostReq } from './api';
import { WEB_LIST_LIMIT } from './locationsService';

// Web API (/api/web/v1), used by the Checkpoints page.

/** The partner system a checkpoint is integrated with. */
export type Partner = {
  id: string;
  name: string;
};

export type AgencyQuestionSummary = {
  id: string;
  question: string;
  description: string | null;
  kind: string | null;
};

export type CheckpointRule = {
  id: string;
  agency_question_id: string;
  checkpoint_id: number;
  enabled: boolean;
  agency_question: AgencyQuestionSummary;
};

export type DeviceConfiguration = {
  id: number;
  device_name: string;
  device_uuid: string;
};

export type Checkpoint = {
  id: number;
  name: string;
  description: string | null;
  pin_required: boolean;
  check_in_enabled: boolean;
  location_id: number;
  /** null for the agency's own checkpoints. */
  partner: Partner | null;
  checkpoint_rules: CheckpointRule[];
  device_configurations: DeviceConfiguration[];
};

export const fetchCheckpoints = async (accessToken: string, locationId: number) => {
  return webGetReq<Checkpoint[]>(
    `/locations/${locationId}/checkpoints?limit=${WEB_LIST_LIMIT}`,
    accessToken
  );
};

/**
 * What's sent to create or update a checkpoint. `checkpoint_rules` turns each
 * agency question on or off; the API leaves any question not sent as it was.
 */
export type CheckpointFields = {
  name: string;
  description: string | null;
  pin_required: boolean;
  check_in_enabled: boolean;
  checkpoint_rules: { agency_question_id: string; enabled: boolean }[];
};

export const createCheckpoint = async (
  accessToken: string,
  locationId: number,
  checkpoint: CheckpointFields
) => {
  return webPostReq<Checkpoint>(`/locations/${locationId}/checkpoints`, accessToken, {
    checkpoint,
  });
};

export const updateCheckpoint = async (
  accessToken: string,
  checkpointId: number,
  checkpoint: CheckpointFields
) => {
  return webPatchReq<Checkpoint>(`/checkpoints/${checkpointId}`, accessToken, { checkpoint });
};

/** The API refuses (409) for a partner checkpoint. */
export const deleteCheckpoint = async (accessToken: string, checkpointId: number) => {
  return webDeleteReq(`/checkpoints/${checkpointId}`, accessToken);
};
